// @import dependencies
import React, {Component} from 'react'
// @end

// @import components
import {MoocScreenLayout} from 'app_components/screens/landing/mooc'
// @end

// @ADD Component types
interface IMoocScreenProps {}
interface IMoocScreenState {}

class MoocScreen extends Component<IMoocScreenProps, IMoocScreenState> {

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IMoocScreenProps) {
    super(props)
    this.state = {}
  }

  render() {
    return(
      <MoocScreenLayout
        {...this.props}
      />
    )
  }
}

export default MoocScreen
